import { PersistOptions, StorageValue } from "zustand/middleware";

/**
 * Обёртка для sessionStorage, совместимая с zustand/middleware/persist.
 * @param name Ключ для хранения в sessionStorage
 * @param partialize (необязательно) Функция для выбора части состояния, которую нужно сохранять
 */
export function createSessionStoragePersist<T>(
  name: string,
  partialize?: (state: T) => T // ⚠️ тип строго T, иначе TypeScript ругался бы
): PersistOptions<T, T> {
  return {
    name,
    storage: {
      getItem: (key): StorageValue<T> | null => {
        try {
          const value = sessionStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        } catch (err) {
          console.warn("❌ Ошибка при чтении из sessionStorage:", err);
          return null;
        }
      },
      setItem: (key, value: StorageValue<T>) => {
        try {
          sessionStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
          console.warn("❌ Ошибка при записи в sessionStorage:", err);
        }
      },
      removeItem: (key) => {
        sessionStorage.removeItem(key);
      },
    },
    // 🛡️ Передаём partialize только если она передана, иначе будет undefined и вызовет ошибку
    ...(partialize ? { partialize } : {}),
  };
}
